/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Driver } from "./Driver";
export const FileJobConfig = core.serialization.object({
    driver: Driver,
    options: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    detectedHeaderRow: core.serialization.number().optional(),
});
